import $utils from '@/utils/utils'
import $api from '@/http/api'
import $common from '../common'

export default {
	namespaced: true,
	state: {
		token: '',
		openid: '',
		unionid: '',
		serveDateTime: '0',
		patientInfo: {},
		detectType:{}
	},
	getters: {
		getToken: state => $common.storeGetterLocalCommon(state, 'token'),
		getOpenid: state => $common.storeGetterLocalCommon(state, 'openid'),
		getUnionid: state => $common.storeGetterLocalCommon(state, 'unionid'),
		patientInfo: state => $common.storeGetterSessionCommon(state, 'patientInfo', 'object')
	},
	mutations: {
		['SET_TOKEN'](state, token) {
			state.token = token
			window.localStorage.setItem('token', token)
		},
		['SET_OPENID'](state, openid) {
			state.openid = openid
			window.localStorage.setItem('openid', openid)
		},
		['SET_UNIONID'](state, unionid) {
			state.unionid = unionid
			window.localStorage.setItem('unionid', unionid)
		},
		['SET_PATIENT_INFO'](state, val) {
			state.patientInfo = val
			window.sessionStorage.setItem('patientInfo', JSON.stringify(state.patientInfo))
		},
		['SET_SERVE_DATETIME'](state, val) {
			state.serveDateTime = val
		},
		['CLEAR'](state) {
			Object.keys(state).forEach(key => {
				if (typeof state[key] === 'string') state[key] = ''
				else if ($utils.isArray(state[key])) state[key] = []
				else state[key] = {}
			})
			// window.localStorage.clear()
			window.sessionStorage.clear()
		},
		['SET_DETECT_TYPE'](state, detectType=[]) {
			var typeKey = {};
			detectType.map((v) => {
				typeKey[v.code] = v.name;
			});
			state.detectType = typeKey;
		},
	},
	actions: {
		// 获取用户信息
		async getUserInfo ({ commit }) {
			const res = await $api.account.getUserDetail()
			if (!res.code) {
				commit('SET_PATIENT_INFO', res.data)
			}
		},
		// 获取当前服务器时间的时间戳
		async actionGetDateTime({ commit }) {
			const res = await $api.account.getDateTime()
			if (!res.code) {
				commit('SET_SERVE_DATETIME', res.data)
			}
		},
		// 获取样本类型字典值
		async getDetectTypeList ({ commit }) {
			const res = await $api.order.sampleList()
			if (!res.code) {
				commit('SET_DETECT_TYPE', res.data)
			}
		},
	}
}
